import React, { memo } from 'react'

// Libraries
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'

// Components

import SocialIcons from './SocialIcon/SocialIcons'
import  {Footer} from './Footers/Footer';


const iconData = [
    {
        color: "#828282",
        link: "https://www.facebook.com/p/Saiipl-100063896869499/",
        icon: "fab fa-facebook-f"
    },
    {
        color: "#828282",
        link: "https://www.linkedin.com/company/south-african-institute-of-intellectual-property-law-saiipl-/",
        icon: "fab fa-linkedin"
    },
    {
        color: "#828282",
        link: "https://twitter.com/saiipl",
        icon: "fa-brands fa-x-twitter"
    },
]

const FooterStyle03 = (props) => {
    return (
        <Footer theme={props.theme} className={`${props.className ? ` ${props.className}` : ""} footer-style-03`}>
            
            <div className="py-[35px] border-t border-[#ffffff1a]">
                <Container>
                    <Row>
                        <Col md={3} className="sm:mb-[20px]">
                            <Link aria-label="link" to="http://dns.business" className="sm:flex sm:justify-center" target='_blank'>
                                <img src="/assets/img/DNS-Business.png" alt="dns-logo" width="111" height="36" />
                            </Link>
                        </Col>
                        <Col md={6} className="flex justify-center flex-column sm:mb-[20px]">
                            <p className="mb-0 xs:text-center">South African Institute of Intellectual Property Law &copy; {new Date().getFullYear()}</p>
                            <p className="mb-0 xs:text-center"><a href="http://www.saiipl.co.za/" target="_blank">www.saiipl.co.za</a> | <a href="/content/40">Privacy Policy</a></p>
                        </Col>
                        <Col md={3}>
                            <SocialIcons size="xs" theme="social-icon-style-01" className="felx justify-end md:justify-center" iconColor={props.theme === "dark" ? "light" : "dark"} data={iconData} />
                        </Col>
                    </Row>
                </Container>
            </div>
        </Footer>
    )
}


export default memo(FooterStyle03)
